<template>
  <div class="checkout-wrap">
    <div class="complete-container">
      <LoadingSpinner v-if="loading" />
      <div v-else class="complete-wrapper">
        <AnimationItem class="animation-complete" :animation="animationConfig" :key="'anim_complete'" />
        <div class="complete-content" v-if="state==='success'">
          <h1>{{ $gettext('Your payment was successful!') }}</h1>
          <div class="complete-reference">Reference: <span>{{ merchantReference }}</span></div>
          <p>{{ $gettext('You will be charged again at the start of the next payment period using the same payment method. If you wish to change this you can do so at any time.') }}</p>
          <p>{{ $gettext('You should receive an invoice in your email shortly and the invoice will be copied in your cost tab if you requested that option.') }}</p>
          <div>
            <GekkoButton
              :text="$gettext('View Subscription')"
              :to="manageSubscriptionsUrl"
              class="mr-2"
            />
            <GekkoButton
              :text="$gettext('Go to Dashboard')"
              :href="Urls['gekko_dashboard']()"
            />
          </div>
        </div>
        <div class="complete-content" v-if="state==='fail'">
          <h1>{{ $gettext('Payment Failed!') }}</h1>
          <p>{{ $gettext('Something went wrong.') }}</p>
          <p>{{ $gettext('We had trouble processing your request or you canceled the transaction, if not please try again, next time is the charm :-)') }}</p>
          <div>
            <GekkoButton 
              :text="$gettext('Manage Subscriptions')"
              :to="manageSubscriptionsUrl"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import PlanTransactionService from "@/store/services/plantransaction.service.js";
import settingsPageSetup from "@/mixins/settingsPageSetup";
import GekkoButton from "@/components/GekkoButton";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue'
import * as successAnimation from '@/css/animations/success-check.json';
import * as failureAnimation from '@/css/animations/failure-cross.json';

export default {
  name: "PaymentComplete",
  mixins: [ settingsPageSetup ],
  components: { GekkoButton, AnimationItem, LoadingSpinner },
  data () {
    return {
      isCheckout: false,
      pageSettings: {
        title: '',
        showCompanyPicker: false,
      },
      state: 'none',
      merchantReference: null,
      loading: true,
      animationConfig: {
        loop: false
      },
    }
  },
  created () {
    // The user returns here after a successful payment.
    // The GET params should look something like this:

    // http://yourSite.com/pRes.jsp?merchantReference=Internet%20Order
    // %2012345&skinCode=4aD37dJA&shopperLocale=en_GB&authResult=AUTHORISED&pspReference=1211992213193029
    // &merchantSig=CPb2cObMxmIIE0khO8WhEYyKDJs%3D
    // MULTISAFEPAY: http://127.0.0.1:8000/en/subscriptions/payment-complete/?transactionid=15012026-WIF41RIB

    PlanTransactionService.validate({ response: this.$route.query }).then((response) => {
      if (response.data.resultCode === "Authorised") {

        // refresh stored data
        this.loadMainGlobalData().then(() => {
          this.loadSubscriptionsMainData().then(() => {
            this.loading = false;
            this.merchantReference = response.data.merchantReference
            this.animationConfig.animationData = successAnimation.default
            this.state = 'success'
            this.$store.commit('setIsPremium', this.currentCompany.is_premium)
          })
        });
        
      } else {
        this.state = 'fail';
        this.loading = false;
        this.animationConfig.animationData = failureAnimation.default
      }

    })
  },
  computed: {
    ...mapGetters({
      currentUser: "main/getCurrentUser",
      currentCompany: "main/getCurrentCompany"
    }),
    manageSubscriptionsUrl() {
      if (this.currentUser.is_accountant) {
        return { name: 'AccountantSubscriptions' };
      } else {
        return { name: 'Subscriptions' };
      }
    }
  },
  methods: {
    ...mapActions({ 
      loadMainGlobalData: "main/loadMainGlobalData",
      loadSubscriptionsMainData: 'subscriptionStore/loadSubscriptionsMainData'
    }),
    goToDashboard () {
      window.location = this.Urls['gekko_dashboard']()
    }
  },
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">

  .checkout-wrap {
    width: 100%;
    .complete-container {
      height: 100%;
      max-width: 800px;
      position: relative;
      background: white;
      .complete-wrapper {
        display: flex;
        flex-direction: column;
        .animation-complete { max-width: 100px; }
        .complete-content {
          margin-top: 1rem;
          .complete-reference {
            font-size: 14px;
            color: $colorUnassigned;
            span { color: #333; }
            margin-bottom: 1rem;
          }
          h1 { margin: 0; margin-bottom: 1rem; }
          p { color: $colorUnassigned; }
        }
      }
      @media(min-width: '768px'){
        padding: 2rem;
        border-radius: 24px;
        overflow: hidden;
        border: 1px solid $colorBgDash;
        // box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
        .complete-wrapper {
          flex-direction: row;
          .animation-complete { max-width: 80px; }
          .complete-content {
            margin: 0; margin-left: 1rem;
          }
        }
      }
    }
  }


</style>
